/**
 * Normalizes a relative path so it doesn't start with '/' or './'.
 * @param path - The path to normalize
 * @returns The normalized path
 */
export function normalizeRelativePath(path) {
    return path.replace(/^\.?\//, '');
}
//# sourceMappingURL=normalize_relative_path.js.map